module.exports = __webpack_public_path__ + "MK.png?362bc4fa6dc05eba2db02f0d4f35633d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/MK.png
// module id = 381
// module chunks = 0